import { defineStore } from "pinia";
import { type Order } from "@src/api";
import { normalize } from "@src/utils";

type OrdersState = {
  ids: string[];
  isOrderListLoaded: boolean;
  isOrderHistoryLoaded: boolean;
  map: Record<string, Order>;
  historyIds: string[];
};

const stateDefault: OrdersState = {
  ids: [],
  isOrderListLoaded: false,
  isOrderHistoryLoaded: false,
  map: {},
  historyIds: [],
};

export const useOrderListStore = defineStore("order_list", {
  state: () => stateDefault,
  actions: {
    add(order: Order) {
      this.ids.push(order.order_id);
      this.map[order.order_id] = order;
    },
    get(orderId: string) {
      return this.map[orderId];
    },
    set(orderList: Order[]) {
      this.isOrderListLoaded = true;
      const normalized = normalize<Order, "order_id">(orderList, "order_id");

      this.map = { ...this.map, ...normalized.map };
      this.ids = normalized.ids;
    },
    setHistory(orderList: Order[]) {
      this.isOrderHistoryLoaded = true;
      const normalized = normalize<Order, "order_id">(orderList, "order_id");

      this.map = { ...this.map, ...normalized.map };
      this.historyIds = normalized.ids;
    },
    updateOrder(order: Pick<Order, "order_id"> & Partial<Order>) {
      this.map[order.order_id] = { ...this.map[order.order_id], ...order };
    },
    deleteOrder(orderId: string) {
      delete this.map[orderId];

      this.ids = this.ids.filter((id) => id !== orderId);
      this.historyIds = this.historyIds.filter((id) => id !== orderId);
    },
    clear() {
      this.ids = [];
      this.map = {};
      this.historyIds = [];
    },
  },
  getters: {
    new: (state) => state.ids.filter((id) => state.map[id].status === "request").length,
  },
});
